export enum ActiveTicketTypeTab {
  All = 0,
  CashOut = 1,
  Live = 2,
}
